// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2G-O_","colCheckbox":"styles_colCheckbox__3SP0i"};